export const SMOCKING_QUESTION_NAME = 'Risk of Smoking';
export const FALL_RISK_QUESTION_NAME = 'Fall Risk';
